import { render, staticRenderFns } from "./InstallationSteps.vue?vue&type=template&id=2515bd44&scoped=true&"
import script from "./InstallationSteps.vue?vue&type=script&lang=ts&"
export * from "./InstallationSteps.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationSteps.vue?vue&type=style&index=0&id=2515bd44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515bd44",
  null
  
)

export default component.exports